export interface CopilotFixDialogSubmitOptions {
  createPullRequest: boolean
  instructions: string
  model: string
}

export interface KnownBillingEntityError {
  match: string
  message: string
  docsLink: string
  settingsPath: string
}

export class FixWithCopilotError extends Error {
  override name = 'FixWithCopilotError'
  knownError?: KnownBillingEntityError
  constructor(message: string, knownError?: KnownBillingEntityError) {
    super(message)
    this.knownError = knownError
  }
}

export interface ThreadComment {
  filename: string
  message: string
  permalink: string
  hasSuggestion?: boolean
  suggestionHtml?: string
  /** Structured suggestion data for client-side HTML rendering. */
  suggestion?: AutomatedSuggestion
  /** e.g. "present" when a suggestion is available. */
  suggestionState?: string
  /** Server-rendered description HTML (markdown rendered via Goomba). */
  descriptionHtml?: string
}

export interface SuggestionDiffLine {
  type: string
  text: string
  left: number | null
  right: number | null
}

export interface SuggestionDiffEntry {
  path: string
  diffLines: SuggestionDiffLine[]
}

export interface AutomatedSuggestion {
  diffEntries: SuggestionDiffEntry[]
}
